module.exports = __webpack_public_path__ + "img/w-explore-bottle.fcba5d36.svg";